module.exports = __webpack_public_path__ + "static/media/ambulance.70c7f1c5.svg";